import { Component, Input, OnInit } from '@angular/core';
import { InfoTooltipComponent } from '../info-tooltip.component';

@Component({
  selector: 'wchfs-info-tooltip-toggle',
  templateUrl: 'info-tooltip-toggle.component.html',
  styleUrls: ['info-tooltip-toggle.component.scss'],
})
export class InfoTooltipToggleComponent implements OnInit {
  @Input() tooltip: InfoTooltipComponent;
  @Input() relativeEl: Element;
  @Input() forceRightAuto = false;

  open(event: Event): void {
    event.stopPropagation();
    this.tooltip.openTooltip();
    setTimeout(() => this.updateTooltipPos());
  }

  ngOnInit() {
    this.updateTooltipPos();
  }

  updateTooltipPos() {
    const tooltipEl = this.tooltip.elementRef.nativeElement;
    const rect = tooltipEl.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const distanceLeft = rect.left;
    const distanceRight = viewportWidth - rect.right;

    if (distanceLeft < distanceRight) {
      tooltipEl.style.left = '0';
      tooltipEl.style.right = 'auto';
    } else {
      tooltipEl.style.right = '0';
      tooltipEl.style.left = 'auto';
    }
  }
}
